/**
 * Region Selected Store
 * Stores the selected region, district, and ward for address forms
 * @see mobile: module-customer/src/stores/region-selected.store.ts
 */

import { observable } from '@legendapp/state';
import type { District, Region, Ward } from '../types/front.graphql';

type RegionSelectedStore = {
    region: (Region & { name: string }) | undefined;
    district: (District & { name: string }) | undefined;
    ward: (Ward & { name: string }) | undefined;
};

export const regionSelectedStore$ = observable<RegionSelectedStore>({
    region: undefined,
    district: undefined,
    ward: undefined,
});
